import Vue from 'vue'
//引入element-ui相关
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

//引入iview-ui相关 
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
Vue.use(ViewUI)

import App from './App'
import router from './router'
import store from './store'

import '../static/UEditor/ueditor.config.js'
import '../static/UEditor/ueditor.all.js'
import '../static/UEditor/lang/zh-cn/zh-cn.js'
import '../static/UEditor/ueditor.parse.min.js'


import { getUser } from './utils/auth'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if(to.meta.title){
    document.title = to.meta.title
  }

  if(to.meta.requireAuth && getUser() == undefined){
    next({
      path: '/login',
      query: { redirect: to.fullPath}
    })
  }

  if(getUser()){
    store.commit('SET_USER', JSON.parse(getUser()))
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js